import ExcelJS from 'exceljs'
import FileSaver from 'file-saver'
import _pick from 'lodash/pick'
import _map from 'lodash/map'

export async function downloadExcelFile ({ sheetList, filename }) {
  const workbook = new ExcelJS.Workbook()

  sheetList.forEach(({ headers, rows, sheetname }) => {
    const sheet = workbook.addWorksheet(sheetname, {
      views: [{ state: 'frozen', xSplit: 0, ySplit: 1 }],
    })
    sheet.columns = headers
    sheet.addRows(rows.map(row => _pick(row, _map(headers, 'key'))))
  })

  // Write workbook file
  const data = await workbook.xlsx.writeBuffer()
  const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
  FileSaver.saveAs(blob, `${filename}.xlsx`)
}
